import { Inject, Injectable } from '@angular/core';
import { SWRole, PWRole, UserService, EDURole } from './user.service';
import { SettingsService } from './settings.service';
import { CognitoService } from './cognito.service';
import { AppService } from './app.service';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { MessageService, MessagePromptOpened } from './message.service';
import { AuthService } from './auth.service';
import { PwAlertDialogComponent } from '../ui-test/pw-alert-dialog/pw-alert-dialog.component';

export enum Feature {
  convert = 'convert',
  tts = 'tts',
  ocr = 'ocr',
  pdfOcr = 'pdfOcr',
  pe = 'pe',
  localaca = 'localaca',
  pdfTextFiltering = 'pdfTextFiltering',
  saveInput = 'saveInput',
  bookmark = 'bookmark',
  annotation = 'annotation',
  voiceCloning = 'voiceCloning',
}

let authorizerServiceFactory = (
  settingsService: SettingsService,
  cognitoService: CognitoService,
  userService: UserService,
  messageService: MessageService,
  authService: AuthService,
  dialog: MatDialog) => {
  if (AppService.isPW() || AppService.isIOS() || AppService.isAndroid()) {
    console.log("authorizer factory: is pw");
    return new PWAuthorizerService(settingsService, cognitoService, userService, messageService, authService, dialog);
  } else {
    console.log("authorizer factory: is sw");
    return new SWAuthorizerService(settingsService, cognitoService, userService, messageService, authService, dialog);
  }
};

@Injectable({
  providedIn: 'root'
})
export abstract class AuthorizerService {
  protected checkList: Object = null;
  protected authPromptRef: any = null;
  constructor(
    protected settingsService: SettingsService,
    protected cognitoService: CognitoService,
    protected userService: UserService,
    protected messageService: MessageService,
    protected authService: AuthService,
    protected dialog: MatDialog
  ) {
    console.log("check list", this.checkList);
  }

  protected abstract initCheckList();
  // protected initCheckList() 
  // return;
  // };

  public isAuthorized(feature: string, showOrderPrompt: boolean = false, showAuthPrompt: boolean = true) {
    console.log('isAuthorized ', feature, showOrderPrompt)
    let acceptedRoles: Array<string> = [];
    let role = this.userService.getUserRole();
    console.log("convert role", role);
    let isLoggedIn = this.cognitoService.getIsLoggedIn();
    let temp = this.checkList[feature];
    let voiceType = null;
    console.log("user status", { role: role, isLoggedIn: isLoggedIn });
    if (feature === Feature.ocr || feature === Feature.pdfOcr ||
      feature === Feature.pe || feature === Feature.pdfTextFiltering ||
      feature === Feature.saveInput || feature === Feature.bookmark ||
      feature === Feature.annotation || feature === Feature.voiceCloning) {
      acceptedRoles = temp ? temp : [];
    } else {
      voiceType = this.settingsService.getSelectedVoiceType();
      acceptedRoles = temp ? temp[voiceType] : [];
    }
    console.log("accepted roles", acceptedRoles);
    let isAuthorized = acceptedRoles && acceptedRoles.includes(role);
    if (isAuthorized) {
      console.log("isAuthorized but not logged in");
      if (!isLoggedIn) {
        if (feature === Feature.tts || feature === Feature.pdfTextFiltering) {
          console.log("checking tts auth", voiceType);
          // if (voiceType === 'plus') {
          //   return false;
          // } else {
          //   return true;
          // }
          return true;
        }
        if (showAuthPrompt) {
          this.showAuthPrompt();
        }
        return false;
      } else {
        return true;
      }
    } else {
      // if (isLoggedIn && role === PWRole.premium && feature === 'convert' && voiceType === 'plus') {
      //   this.userService.upgradeSubscription(true);
      // } else {
      if (showOrderPrompt) {
        this.userService.showOrderPrompt(feature);
      }
      // }
      return false;
    }
  }

  public showAuthPrompt() {
    console.log("showAuthPrompt");
    console.log("showAuthPrompt: ", this.authPromptRef);
    if (!this.authPromptRef) {
      console.log("showAuthPrompt: true");
      this.messageService.sendMessage({ name: MessagePromptOpened });
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = false;
      // dialogConfig.width = '375px';
      dialogConfig.panelClass = 'pw-full-handset';
      dialogConfig.backdropClass = 'pw-dialog-backdrop';
      dialogConfig.data = {
        type: 'alert',
        title: 'Login Required',
        msg: 'Please sign up or login to use this feature!',
        buttonText: 'Signup/Login'
      };
      this.authPromptRef = this.dialog.open(PwAlertDialogComponent, dialogConfig);
      this.authPromptRef.afterClosed().subscribe(result => {
        this.messageService.sendMessage({ name: 'MessageCloseDialog' })
        if (result === 'OK') {
          this.authService.loginBtnOnClick();
        }
        this.authPromptRef = null;
      });
    }
  }
}

export class PWAuthorizerService extends AuthorizerService {
  constructor(
    @Inject(SettingsService) settingsService: SettingsService,
    @Inject(CognitoService) cognitoService: CognitoService,
    @Inject(UserService) userService: UserService,
    @Inject(MessageService) messageService: MessageService,
    @Inject(AuthService) authService: AuthService,
    @Inject(MatDialog) dialog: MatDialog,
  ) {
    super(settingsService, cognitoService, userService, messageService, authService, dialog);
    this.initCheckList();
  }

  protected initCheckList() {
    // TODO: edu
    this.checkList = new Object();
    let convert = {
      'free': [PWRole.premium, EDURole.premium, PWRole.plus, EDURole.plus],
      'prem': [PWRole.premium, EDURole.premium, PWRole.plus, EDURole.plus],
      'plus': [PWRole.plus, EDURole.plus]
    };

    let tts = {
      'free': [PWRole.free, PWRole.premium, EDURole.premium, PWRole.plus, EDURole.plus],
      'prem': [PWRole.free, PWRole.premium, EDURole.premium, PWRole.plus, EDURole.plus],
      'plus': [PWRole.free, PWRole.premium, EDURole.premium, PWRole.plus, EDURole.plus]
    };

    let ocr = [PWRole.free, PWRole.premium, EDURole.premium, PWRole.plus, EDURole.plus];
    let pdfOcr = [PWRole.premium, EDURole.premium, PWRole.plus, EDURole.plus];
    const pdfTextFiltering = [PWRole.free, PWRole.premium, PWRole.plus, EDURole.premium, EDURole.plus];
    let pe = [PWRole.free, PWRole.plus, PWRole.premium, EDURole.premium, EDURole.plus];
    const saveInput = [PWRole.free, PWRole.plus, PWRole.premium, EDURole.premium, EDURole.plus];
    let bookmark = [PWRole.free, PWRole.premium, EDURole.premium, PWRole.plus, EDURole.plus];
    let annotation = [PWRole.free, PWRole.premium, EDURole.premium, PWRole.plus, EDURole.plus];
    let voiceCloning = [PWRole.free, PWRole.premium, EDURole.premium, PWRole.plus, EDURole.plus];

    this.checkList[Feature.convert] = convert;
    this.checkList[Feature.tts] = tts;
    this.checkList[Feature.ocr] = ocr;
    this.checkList[Feature.pdfOcr] = pdfOcr;
    this.checkList[Feature.pe] = pe;
    this.checkList[Feature.pdfTextFiltering] = pdfTextFiltering;
    this.checkList[Feature.saveInput] = saveInput;
    this.checkList[Feature.bookmark] = bookmark;
    this.checkList[Feature.annotation] = annotation;
    this.checkList[Feature.voiceCloning] = voiceCloning;
  }
}

export class SWAuthorizerService extends AuthorizerService {
  constructor(
    @Inject(SettingsService) settingsService: SettingsService,
    @Inject(CognitoService) cognitoService: CognitoService,
    @Inject(UserService) userService: UserService,
    @Inject(MessageService) messageService: MessageService,
    @Inject(AuthService) authService: AuthService,
    @Inject(MatDialog) dialog: MatDialog
  ) {
    super(settingsService, cognitoService, userService, messageService, authService, dialog);
    this.initCheckList();
  }

  protected initCheckList() {
    this.checkList = new Object();
    let convert = {
      'free': [SWRole.personal, SWRole.pro, SWRole.ultimate]
    };

    let tts = {
      'free': [SWRole.free, SWRole.personal, SWRole.pro, SWRole.ultimate]
    };

    let ocr = [SWRole.free, SWRole.personal, SWRole.pro, SWRole.ultimate];
    let pdfOcr = [SWRole.ultimate];

    let pe = [SWRole.free, SWRole.personal, SWRole.pro, SWRole.ultimate];
    let annotation = [SWRole.free, SWRole.personal, SWRole.pro, SWRole.ultimate];
    let voiceCloning = [SWRole.free, SWRole.personal, SWRole.pro, SWRole.ultimate];
    this.checkList[Feature.convert] = convert;
    this.checkList[Feature.tts] = tts;
    this.checkList[Feature.ocr] = ocr;
    this.checkList[Feature.pdfOcr] = pdfOcr;
    this.checkList[Feature.pe] = pe;
    this.checkList[Feature.annotation] = annotation;
    this.checkList[Feature.voiceCloning] = voiceCloning;
  }
}

export let authorizerServiceProvider =
{
  provide: AuthorizerService,
  useFactory: authorizerServiceFactory,
  deps: [SettingsService, CognitoService, UserService, MessageService, AuthService, MatDialog]
};
